class CartItems extends HTMLElement {
    constructor() {
        super();

        // 1. Guardar referencias de los métodos con bind para que el removeEventListener funcione correctamente
        this.boundOnButtonClick = this.onButtonClick.bind(this);
        this.boundOnRemoveItemClick = this.onRemoveItemClick.bind(this);

        this.cartCountDown = document.getElementById(`CartCountdown-${this.dataset.section}`);
        this.toCheckoutButton = document.getElementById('cart-checkout');
        this.couponCodeInput = document.getElementById('cart-coupon-code');
        this.cartNoteInput = document.getElementById('cart-note');
        this.checkTerms = document.getElementById('cart_conditions');

        this.toCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this));

        this.initToCheckoutButtonDisabling();
        this.initCartCountdown();
        
        // 2. Agrupamos los elementos que necesitan reinicializarse al actualizar el DOM del carrito
        this.reinitEvents();
    }

    reinitEvents() {
        // Obtenemos los elementos que se destruyen/crean cuando actualizamos this.innerHTML
        this.giftCardElement = document.getElementById('is-a-gift');
        this.giftCardButton = document.getElementById('cart-gift-wrapping');
        this.removeButtons = this.querySelectorAll('[data-cart-remove]');

        if (this.giftCardElement) this.initGiftCardElement();
        this.initGiftCardManipulation();
        this.initQuantityUpdateButtons();
        
        // Inicializamos los botones de eliminar
        this.initRemoveButtons();
    }

    initRemoveButtons() {
        this.removeButtons.forEach(button => {
            button.removeEventListener('click', this.boundOnRemoveItemClick);
            button.addEventListener('click', this.boundOnRemoveItemClick);
        });
    }

    async onRemoveItemClick(event) {
        event.preventDefault();
        const button = event.currentTarget;

        // Extraer el ID de la variante o line item desde un data attribute o el href del botón
        let id = button.dataset.cartRemoveId || button.dataset.id;
        let url = button.getAttribute('href');

        if (!id && url) {
            const urlObj = new URL(url, window.location.origin);
            id = urlObj.searchParams.get('id') || urlObj.searchParams.get('line');
        }

        if (!id) return; // Si no encontramos qué eliminar, detenemos la ejecución

        try {
            const sectionId = this.dataset.section || 'main-cart-items';

            // Petición a Shopify para remover el artículo y pedir la sección actualizada
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    quantity: 0,
                    sections: sectionId, 
                    sections_url: window.location.pathname
                })
            });

            const parsedState = await response.json();

            // Si Shopify devuelve el HTML de la sección, actualizamos el DOM
            if (parsedState.sections && parsedState.sections[sectionId]) {
                const html = new DOMParser().parseFromString(parsedState.sections[sectionId], 'text/html');
                const newCartItems = html.querySelector('cart-items') || html.getElementById(`CartItems-${sectionId}`);

                if (newCartItems) {
                    this.innerHTML = newCartItems.innerHTML;
                    // Al reemplazar el HTML, los eventos previos mueren. Hay que reconectarlos:
                    this.reinitEvents();
                } else {
                    window.location.reload(); // Fallback de seguridad
                }
            } else {
                window.location.reload(); // Fallback de seguridad
            }

        } catch (error) {
            console.error(`Error al eliminar el producto: ${error.message}`);
            window.location.reload(); 
        }
    }

    initQuantityUpdateButtons() {
         this.querySelectorAll('.btn-quantity').forEach(button => {
             // Usamos la referencia guardada en lugar de .bind(this) directamente
             button.removeEventListener('click', this.boundOnButtonClick);
             button.addEventListener('click', this.boundOnButtonClick);
         });
    }

    onButtonClick(event) {
         event.preventDefault();
         const inputElement = event.target.parentElement.querySelector('.quantity');
         const value = Number(inputElement.value);
         let newVal;
         
         if (event.target.classList.contains('plus')) {
             newVal = value + 1;
         } else {
             newVal = value - 1;
         }

         if (newVal >= 0) {
             const changeEvent = new Event('change', { bubbles: true });
             inputElement.value = newVal;
             inputElement.dispatchEvent(changeEvent);
         } 
    }

    initGiftCardElement() {
        const isChecked = this.giftCardButton?.dataset.isChecked;
        if (isChecked === 'true') {
            const variantId = this.giftCardButton?.dataset.giftId;
            const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`);
            const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`);

            this.giftCardElement.style.display = 'none';
            giftCardRemoveButton?.addEventListener('click', () => {
                this.giftCardButton.dataset.isChecked = 'false';
            });

            giftCardQuantityInput?.addEventListener('change', (e) => {
                const value = Number(e.target.value);
                if (value  <= 0) {
                    this.giftCardButton.dataset.isChecked = 'false';
                }
            });
        } else {
          this.giftCardElement.style.display = 'flex';
        }
    }

    initGiftCardManipulation() {
        if (this.giftCardButton) {
            // Aquí también sería ideal guardar la referencia en el constructor si se llama varias veces,
            // pero lo dejaremos sencillo por ahora para no modificar en exceso tu lógica externa.
            this.giftCardButton.removeEventListener('click', this.onAddGiftCardClick.bind(this));
            this.giftCardButton.addEventListener('click', this.onAddGiftCardClick.bind(this));
        }
    }

    onAddGiftCardClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.giftCardButton.dataset.isChecked = 'true';
    }

    initToCheckoutButtonDisabling() {
        if (this.checkTerms) {
            window.addEventListener('load', () => {
                this.toCheckoutButton.disabled = !this.checkTerms.checked;
            });
        }
    }

    async handleToCheckoutPage(e) {
        e.preventDefault();

        try {
            // saving coupon
            const couponCode = this.couponCodeInput?.value;
            if (couponCode) {
                localStorage.setItem('storedDiscount', couponCode);
                const couponRes =  await fetch(`/discount/${couponCode}`);
                await couponRes.text();
            }
            
            // saving cart note
            const cartNote = this.cartNoteInput?.value;
            if (cartNote) {
                const cartNoteBody = JSON.stringify({ note: cartNote });
                const cartNoteRes = await fetch(`${window.routes?.cart_update_url || '/cart/update.js'}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: cartNoteBody 
                });
                await cartNoteRes.text();
            }

        } catch(error) {
            console.error(`Error: ${error.message}`);
        }

        let checkoutHref = this.toCheckoutButton.dataset.href;
        if (checkoutHref == null) {
            checkoutHref = `${window.routes?.root ? window.routes.root : ""}/checkout`;
        }
        
        window.location = checkoutHref;
    }

    initCartCountdown(){
        if(!this.cartCountDown) return;

        if(!this.cartCountDown.classList.contains('is-running')){
            const duration = this.cartCountDown.getAttribute('data-cart-countdown') * 60;
            const element = this.cartCountDown.querySelector('.time');

            this.cartCountDown.classList.add('is-running');
            this.startTimerCartCountdown(duration, element);
        }
    }

    startTimerCartCountdown(duration, element){
        var timer = duration, minutes, seconds, text;

        var startCoundown = setInterval(() => {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            text = minutes + ":" + seconds;

            element.innerText = text;

            if (--timer < 0) {
                clearInterval(startCoundown);
                this.cartCountDown.remove();
            }
        }, 1000);
    }
}

customElements.define('cart-items', CartItems);